import { ACTIVE, EXPIRED, INACTIVE } from '../constants';

export const statusActive = (item) => item.status === ACTIVE;
export const statusExpired = (item) => item.status === EXPIRED;
export const statusInactive = (item) => item.status === INACTIVE;

export const countActiveSubscriptions = (list) => {
  return list.filter((sub) => sub.active).length;
};
